"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSegmentationToolbar = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../../utils");
var icon_definitions_1 = require("../constants/icon-definitions");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var buttons = [
    {
        tooltip: 'Plot Positive Point',
        ariaLabel: 'Plot Positive Point',
        id: '+',
        icon: react_1.default.createElement(icon_definitions_1.PositivePointIcon, null)
    },
    {
        tooltip: 'Plot Negative Point',
        ariaLabel: 'Plot Negative Point',
        id: '-',
        icon: react_1.default.createElement(icon_definitions_1.NegativePointIcon, null)
    }
];
exports.AutoSegmentationToolbar = (0, react_1.memo)(function (_a) {
    var onButtonClick = _a.onButtonClick, plotMode = _a.plotMode;
    var buttonsWithHandler = (0, react_1.useMemo)(function () {
        return buttons.map(function (btn) {
            return (0, utils_1.t)(btn, function () { return onButtonClick(btn.id); }, btn.id === plotMode ? { color: 'red' } : {});
        });
    }, [onButtonClick, plotMode]);
    return (react_1.default.createElement(Root, null, buttonsWithHandler.map(function (_a) {
        var _b = tslib_1.__read(_a, 3), button = _b[0], handler = _b[1], style = _b[2];
        return (react_1.default.createElement(core_1.Tooltip, { key: button.id, title: button.tooltip, "aria-label": button.ariaLabel, placement: 'left' },
            react_1.default.createElement(core_1.IconButton, { disableTouchRipple: true, style: style, onClick: handler }, button.icon)));
    })));
});
exports.AutoSegmentationToolbar.displayName = 'AutoSegmentationToolbar';
var templateObject_1;
